<template>
  <div class="login-container">
    <div class="login-card">
      <h2 class="login-title">球杆售后系统</h2>
      <p class="login-subtitle">忘记密码验证</p>

      <el-form
          ref="forgetFormRef"
          :model="forgetForm"
          :rules="forgetRules"
          label-width="100%"
          label-position="top"
          class="login-form"
      >
        <!-- 手机号输入框 -->
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input
              type="number"
              v-model="forgetForm.phoneNumber"
              placeholder="请输入11位手机号"
              prefix-icon="el-icon-phone"
              maxlength="11"
              class="login-input"
          ></el-input>
        </el-form-item>

        <!-- 验证码输入框 -->
        <el-form-item label="短信验证码" prop="code">
          <div class="code-input-wrap">
            <el-input
                v-model="forgetForm.code"
                placeholder="请输入验证码"
                prefix-icon="el-icon-message"
                maxlength="6"
                class="login-input code-input"
            ></el-input>
            <el-button
                class="get-code-btn"
                :disabled="!canGetCode || countDown > 0"
                @click="getSmsCode"
            >
              {{ countDown > 0 ? `${countDown}s后重新获取` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>

        <!-- 下一步按钮 -->
        <el-form-item>
          <el-button
              type="primary"
              :loading="isLoading"
              @click="handleVerifyCode"
              class="login-btn"
          >
            下一步
          </el-button>
        </el-form-item>

        <!-- 返回登录入口 -->
        <div class="register-entry">
          <span class="register-link" @click="goBackLogin">返回登录</span>
        </div>
      </el-form>

      <!-- 提示弹框 -->
      <MessageDialog
          v-if="showDialog"
          title="提示"
          :content="messageContent"
          confirmText="我知道了"
          :showCancel="false"
          @confirm="showDialog = false"
          @close="showDialog = false"
          closeOnMask
      />
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import {sendCode, updatePasswordToVerify} from "@/api/sales"; // 新增验证码验证接口
import MessageDialog from "@/views/business/utils/messageDialog.vue";

export default {
  name: 'SalesForgetPassword',
  components: { MessageDialog },
  data() {
    // 验证码校验规则
    const validateCode = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入验证码'))
      if (!/^\d{6}$/.test(value)) {
        callback(new Error('请输入6位数字验证码'))
      } else {
        callback()
      }
    }

    return {
      // 表单数据
      forgetForm: {
        phoneNumber: '',
        code: ''
      },
      // 校验规则
      forgetRules: {
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号', trigger: 'blur' }
        ],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      isLoading: false,
      // 验证码倒计时
      countDown: 0,
      canGetCode: false,
      timer: null,
      // 弹框相关
      showDialog: false,
      messageContent: ''
    }
  },
  watch: {
    // 监听手机号变化，判断是否可获取验证码
    'forgetForm.phoneNumber'(val) {
      this.canGetCode = /^1[3-9]\d{9}$/.test(val)
    }
  },
  mounted() {
    window.addEventListener('resize', this.adjustContainerHeight)
    this.adjustContainerHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustContainerHeight)
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    // 适配容器高度
    adjustContainerHeight() {
      const container = document.querySelector('.login-container')
      if (container) {
        container.style.minHeight = `${window.innerHeight}px`
      }
    },
    // 获取短信验证码
    async getSmsCode() {
      if (!this.canGetCode) {
        Message.warning('请输入正确的11位手机号！')
        return
      }

      try {
        const res = await sendCode(this.forgetForm.phoneNumber, 'update') // 传标识区分忘记密码场景
        if (res.code === 200) {
          this.showDialog = true
          this.messageContent = '验证码已发送，请注意查收！'
          setTimeout(() => {
            this.showDialog = false
          }, 3000)
          // 开始倒计时
          this.countDown = 60
          this.timer = setInterval(() => {
            this.countDown--
            if (this.countDown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.showDialog = true
          this.messageContent = res.returnMsg || '验证码发送失败，请重试'
        }
      } catch (error) {
        this.showDialog = true
        this.messageContent = error.message || '网络异常，请稍后再试'
      }
    },
    // 验证验证码并跳转重置密码

    handleVerifyCode2() {
      this.$router.push({
        path: '/sales_resetPass',
        query: { phoneNumber: this.forgetForm.phoneNumber }
      })
    },

    async handleVerifyCode() {
      try {
        // 表单校验
        await this.$refs.forgetFormRef.validate()
      } catch (err) {
        this.showDialog = true
        this.messageContent = '请检查表单填写是否正确！'
        return
      }

      this.isLoading = true
      try {
        const verifyParams = {
          phoneNumber: this.forgetForm.phoneNumber,
          // 密码/验证码二选一
           captcha: this.forgetForm.code
        }

        // 调用验证码验证接口
        const res = await updatePasswordToVerify(verifyParams)
        if (res.code === 200) {
          // 验证成功，跳转重置密码页面（携带手机号）
          this.$router.push({
            path: '/sales_resetPass',
            query: { phoneNumber: this.forgetForm.phoneNumber }
          })
        } else {
          this.showDialog = true
          this.messageContent = res.returnMsg || '验证码错误，请重新输入'
        }
      } catch (error) {
        this.showDialog = true
        this.messageContent = error.message || '网络异常，请稍后再试'
      } finally {
        this.isLoading = false
      }
    },
    // 返回登录页
    goBackLogin() {
      this.$router.replace('/sales_login')
    }
  }
}
</script>

<style scoped lang="scss">
/* 复用原登录页的样式，仅调整少量文案相关 */
/* 全局基础 */
body {
  touch-action: manipulation;
  user-select: none;
  margin: 0;
  padding: 0;
}

/* 容器核心布局 */
.login-container {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #409eff, #67c23a);
}

/* 登录卡片核心 */
.login-card {
  position: relative;
  z-index: 1;
  background: #fff;
  border-radius: 24px;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

/* 标题通用样式 */
.login-title {
  color: #333;
  text-align: center;
  margin: 0 0 10px 0;
  font-weight: 700;
  padding-left: 10px;
}

.login-subtitle {
  color: #666;
  text-align: center;
  margin-bottom: 20px;
  padding-left: 10px;
}

/* 输入框通用样式 */
.login-input {
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 18px;
  margin-bottom: 4px;
  padding: 0 56px 0 48px;
}

/* 验证码输入容器通用 */
.code-input-wrap {
  display: flex;
  gap: 10px;
  align-items: center;
}

.code-input {
  flex: 1;
  padding-right: 16px;
}

/* 获取验证码按钮通用 */
.get-code-btn {
  border: none;
  border-radius: 18px;
  background-color: #f5f7fa;
  color: #409eff;
  white-space: nowrap;
}

.get-code-btn:disabled {
  color: #999;
  background-color: #f0f0f0;
}

/* Element Input 通用深度样式 */
::v-deep .el-input__prefix {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 100%;
  transform: none;
}

::v-deep .el-input__prefix i {
  color: #409eff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

::v-deep .el-input__suffix {
  width: 40px;
  height: 40px;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

::v-deep .el-input__suffix i {
  color: #409eff;
  width: 100%;
  height: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}

::v-deep .el-input__inner {
  height: 100%;
  line-height: 48px;
  font-size: 14px;
  border: none;
  padding: 0;
}

/* Element Form 通用深度样式 */
::v-deep .el-form {
  --el-form-border-color: transparent;
}

::v-deep .el-form-item__label {
  color: #555;
  margin-bottom: 10px;
  font-weight: 500;
}

::v-deep .el-form-item__error {
  font-size: 12px;
  padding-top: 2px;
  padding-left: 10px;
}

::v-deep .el-form-item {
  margin-bottom: 24px;
}

/* 下一步按钮样式 */
.login-btn {
  border: none;
  border-radius: 10px;
  background: #409eff;
  color: #fff;
  width: 100%;
  height: 48px;
  font-size: 17px;
  transition: all 0.2s ease;
}

.login-btn:hover {
  background: #3390ff;
}

.login-btn:disabled {
  background: #b3d8ff;
}

/* 返回登录入口样式 */
.register-entry {
  display: flex;
  justify-content: center;
  cursor: pointer;
  padding: 8px 0;
}

.register-link {
  color: #409eff;
  position: relative;
  font-size: 14px;
}

.register-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #409eff;
  transition: width 0.3s ease;
}

.register-entry:hover .register-link::after {
  width: 100%;
}

/* ===================== 移动端适配（< 768px） ===================== */
@media screen and (max-width: 767px) {
  .login-container {
    width: 100vw;
    min-height: 100vh;
    padding: 0 20px;
  }

  .login-card {
    max-width: 400px;
    padding: 40px 25px;
  }

  .login-title {
    font-size: 26px;
    margin-bottom: 10px;
    padding-left: 10px;
  }

  .login-subtitle {
    font-size: 15px;
    margin-bottom: 20px;
    padding-left: 10px;
  }

  .login-input {
    height: 48px;
    font-size: 16px;
    border-radius: 18px;
    padding: 0 16px 0 48px;
    margin-bottom: 4px;
  }

  .get-code-btn {
    width: 110px;
    height: 48px;
    font-size: 14px;
    border-radius: 18px;
  }

  ::v-deep .el-form-item__label {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .login-btn {
    height: 48px;
    font-size: 17px;
    border-radius: 10px;
  }
  /* 前缀图标居中 */
  ::v-deep .el-input__prefix {
    width: 48px;
    height: 100%;
  }

  ::v-deep .el-input__prefix i {
    font-size: 18px;
  }

  /* 输入框内容区 */
  ::v-deep .el-input__inner {
    height: 100%;
    line-height: 48px;
    font-size: 14px;
    padding: 0;
  }

  ::v-deep .el-form-item__error {
    font-size: 12px;
    padding-top: 2px;
    padding-left: 10px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 24px;
  }
  .register-link {
    font-size: 14px;
  }
}

/* ===================== 平板适配（768px ≤ 宽度 < 1200px） ===================== */
@media screen and (min-width: 768px) and (max-width: 1199px) {
  .login-container {
    min-height: 100vh;
    padding: 0 40px;
  }

  .login-card {
    width: 70%;
    max-width: 500px;
    padding: 50px 40px;
    border-radius: 28px;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.18);
  }

  .login-title {
    font-size: 30px;
    margin-bottom: 15px;
  }

  .login-subtitle {
    font-size: 16px;
    margin-bottom: 28px;
  }

  .login-input {
    height: 52px;
    font-size: 17px;
    border-radius: 20px;
  }

  .get-code-btn {
    width: 120px;
    height: 52px;
    font-size: 15px;
    border-radius: 20px;
  }

  ::v-deep .el-form-item__label {
    font-size: 17px;
    margin-bottom: 12px;
  }

  .login-btn {
    height: 52px;
    font-size: 18px;
    border-radius: 12px;
  }
}

/* ===================== PC 端适配（≥ 1200px） ===================== */
@media screen and (min-width: 1200px) {
  .login-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #409eff 0%, #67c23a 100%);
    position: relative;
    padding: 0 50px;
  }

  .login-card {
    width: 100%;
    max-width: 520px;
    padding: 60px 50px;
    border-radius: 32px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .login-title {
    font-size: 32px;
    margin-bottom: 18px;
  }

  .login-subtitle {
    font-size: 17px;
    margin-bottom: 32px;
  }

  .login-input {
    height: 56px;
    font-size: 17px;
    border-radius: 22px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  ::v-deep .login-input:focus .el-input__inner {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
  }

  .get-code-btn {
    width: 130px;
    height: 56px;
    font-size: 15px;
    border-radius: 22px;
    transition: all 0.2s ease;
  }

  .get-code-btn:not(:disabled):hover {
    background-color: #e8f4f8;
    color: #3390ff;
    transform: scale(1.02);
  }

  .get-code-btn:not(:disabled):active {
    transform: scale(0.98);
  }

  ::v-deep .el-form-item__label {
    font-size: 18px;
    margin-bottom: 14px;
  }

  .login-btn {
    height: 56px;
    font-size: 19px;
    border-radius: 14px;
  }

  .login-btn:hover {
    background: #3390ff;
    transform: scale(1.02);
  }

  .login-btn:active {
    transform: scale(0.98);
  }

  .register-link {
    font-size: 15px;
  }
}
</style>